import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerModalBaseComponent } from '../shared/customer-modal-base.component';

export class HistoricalPlacardContext {
    constructor(public customerNumberId: number) {}
}

@Component({
    templateUrl: './historical-customer-placard-modal.html'
})
export class HistoricalCustomerPlacardModalComponent extends CustomerModalBaseComponent {

    constructor(public location: PlatformLocation,
        public dialogRef: MatDialogRef<HistoricalCustomerPlacardModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: HistoricalPlacardContext,
        public modalServices: MvdModalService) {
        super(modalServices);
    }

    ngOnInit() { }

    public cancel() {
        this.dialogRef.close();
    }
}
